import type { ICellRendererParams } from 'ag-grid-community'

import type { GameGridRow } from '../utils/gameGridRows'
import GameStatusTag from './GameStatusTag'

/**
 * The Status column's cell: the shared tag, over the row's derived status.
 *
 * The COLUMN's value is the localized label (`statusLabel`), not this element,
 * which is what lets the search box match "postponed" and the CSV export carry
 * a word rather than an empty cell.
 */
const GameStatusCell = ({ data }: ICellRendererParams<GameGridRow>) => {
  'use memo'

  //  AG Grid renders this cell for its loading and full-width rows with no data.
  if (data === undefined) {
    return null
  }

  return <GameStatusTag status={data.status} />
}

export default GameStatusCell
